// extracted by mini-css-extract-plugin
export var container = "ArticleContent-module--container--xHvfH";
export var text = "ArticleContent-module--text--3bCt6";
export var title = "ArticleContent-module--title--1sGed";
export var introduction = "ArticleContent-module--introduction--2WohF";
export var image = "ArticleContent-module--image--1AokI";
export var content = "ArticleContent-module--content--3r9hf";